import { z } from "zod";
import { AppSettingKey } from "../enums.js";
export const updateAppSettingsSchema = z.object({
    [AppSettingKey.OFFER_EXPIRY_OFFSET_MINUTES]: z
        .coerce.number()
        .int()
        .min(0)
        .max(24 * 60)
        .optional(),
});
//# sourceMappingURL=app-setting.js.map